import { Label } from "@repo/ui/Label/label";
import { Size } from "@repo/ui/helpers/helpers";
import type { FC } from "react";
import { QuestionsManager } from "./questionsManager.js";
import type {
  QuestionsDispatch,
  QuestionWithTemporaryId,
} from "./questionsStore.js";
import { QuestionsSuggestionsWidget } from "./questionsSuggestionsWidget.js";

export interface QuestionsPanelProps {
  projectId: string;
  questions: readonly QuestionWithTemporaryId[];
  onQuestionsChange: QuestionsDispatch;
}

/**
 * Right-side panel before the introduction of interview sections.
 */
export const QuestionsPanel: FC<QuestionsPanelProps> = (props) => (
  <div className="flex flex-1 flex-col">
    <div className="space-between flex flex-col border-b border-border-light bg-background px-3 py-2">
      <div className="flex flex-row items-center space-x-2">
        <Label size={Size.MEDIUM}>Interview questions</Label>
        <QuestionsSuggestionsWidget projectId={props.projectId} />
      </div>
      <div className="text-xs text-gray-600">
        The AI interviewer will automatically ask clarifying questions and adapt
        to the candidate's responses.
      </div>
    </div>
    <div className="flex-1 overflow-y-auto">
      <QuestionsManager
        questions={props.questions}
        onQuestionsChange={props.onQuestionsChange}
      />
    </div>
  </div>
);
